import BaseApi from '@/api/base-api'

const TRANSACTION_REPORT_PATH = '/merchants/orders/transaction/report'
const DOWNLOAD_REQUEST_OPTIONS = {
  options: {
    hideMessage: true,
    camelizeRes: false,
  },
}

class MerchantTransactionApi extends BaseApi {
  /** Legacy GET transaction report (flat query params). */
  downloadTransactions = (data) => {
    return this.request(
      {
        timeout: 100000, // ms
        method: 'GET',
        path: TRANSACTION_REPORT_PATH,
        data: data,
      },
      DOWNLOAD_REQUEST_OPTIONS
    )
  }

  /** New POST transaction report (nested filter payload). */
  downloadTransactionsPost = (data) => {
    return this.request(
      {
        timeout: 100000, // ms
        method: 'POST',
        path: TRANSACTION_REPORT_PATH,
        data: data,
      },
      DOWNLOAD_REQUEST_OPTIONS
    )
  }
}

export default new MerchantTransactionApi('/merchants/transactions')
